import React from "react"
import { Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../lib/Authenticated"
import { canUserSeeThisLoan, fillingZeroUtility } from "../../lib/utils"
import { browserHistory } from "react-router"
import moment from "moment"

export default function LoanSmallCard({ loans }) {

  const authenticated = new Authenticated(),

  isAdmin = authenticated.isAdmin(),

  isUnderwriter = authenticated.isUnderwriter(),

  isApprover = authenticated.isApprover(),

  isPaymentManager = authenticated.isPaymentManager(),

  isAccountant = authenticated.isAccountant()

  if(!loans || !loans.length) return null

  const data = loans
    .map(({ id, bundleQty, bundleName, status, sellingCost, disburseDate }, index) => {

      const enabled = canUserSeeThisLoan(status, isAdmin, isPaymentManager, isApprover, isUnderwriter, isAccountant),

      className = enabled ? 'cursor-pointer' : '',

      title = enabled ? 'Show details' : '',

      onClick = () => enabled ? browserHistory.push(`/loans/${ id }/detail`) : null
  
      return <tr key={`small-loan-${index}`} title={ title } className={ className } onClick={ onClick }>
        <td><small>{ moment(disburseDate).format('ll') }</small></td>
        <td>{ fillingZeroUtility(bundleQty) } x { bundleName }</td>
        <td>{ sellingCost }</td>
        <td><small className="gray">{ status }</small></td>
      </tr>
    }
  )

  return (
    <Table striped condensed hover responsive>
      <caption>
        <FontAwesome name="angle-right" />&nbsp;
        <FontAwesome name="angle-right" />&nbsp;
        <FontAwesome name="angle-right" />&nbsp; Loans
      </caption>
      <tbody>
        { data }
      </tbody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/LoanSmallCard.js